"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Reminder = void 0;
var _localization = require("@lt/localization");
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var Reminder = exports.Reminder = function Reminder() {
  var _useTranslation = (0, _localization.useTranslation)(),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement(StyledReminder, null, t('touristsPicker.reminder'));
};
var StyledReminder = _styledComponents["default"].p.withConfig({
  displayName: "Reminder__StyledReminder",
  componentId: "sc-1yezsmi-0"
})(["width:100%;display:flex;align-items:center;justify-content:center;white-space:pre-line;height:48px;max-height:48px;padding:8px 13px 0;font-size:14px;text-align:center;color:var(--grey1);font-weight:400;font-size:14px;line-height:16px;"]);